import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getContactRoles({ commit }, params = {}) {
    return axios.get(`/contact-roles/search`, { params })
  },
}
